export enum Domain {
  Energy = 'Energy',
  Marine = 'Marine',
}
